import { render } from "./LoginData.vue?vue&type=template&id=3ac0fe7f&ts=true"
import script from "./LoginData.vue?vue&type=script&lang=ts"
export * from "./LoginData.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/zpp/var/code/p-kunden.nsl.software/node-kunden-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__